import type { RoleType } from './roles';

const DELETE_ALLOWED: readonly RoleType[] = ['super_admin', 'ba_super_admin'];

/**
 * BE gates `DELETE /organizations/:orgId/locations/:id` with
 * `requireRole('super_admin', 'ba_super_admin')` (locationRoute.ts:46-53).
 * Same rule as canDeleteOrg, kept as a separate symbol so call sites read
 * intentionally and either rule can diverge later without churning callers.
 */
export function canDeleteLocation(role: RoleType | null): boolean {
  return role !== null && DELETE_ALLOWED.includes(role);
}
